import { PayloadAction } from "@reduxjs/toolkit";
import { IErrorAlertObject, IInitialState } from "./Types";

export const Reducer = {
  showAlert: (state: IInitialState, action: PayloadAction<boolean>): void => {
    state.openErrorAlert = action.payload;
  },
  createErrorAlert: (state: IInitialState, action: PayloadAction<IErrorAlertObject>): void => {
    state.error = action.payload;
    state.openErrorAlert = true;
  }
};
